import { render, staticRenderFns } from "./SiteNavTitle.vue?vue&type=template&id=2f97cf72&scoped=true"
import script from "./SiteNavTitle.vue?vue&type=script&lang=ts"
export * from "./SiteNavTitle.vue?vue&type=script&lang=ts"
import style0 from "./SiteNavTitle.vue?vue&type=style&index=0&id=2f97cf72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97cf72",
  null
  
)

export default component.exports